import { getData } from '../utils/api';

/**
 * Fetch general info by title (e.g. "states").
 * States data shape: [{ state, systemState, zone, short }]
 * @param {string} title - e.g. "states"
 * @returns {Promise<any>}
 */
export const getGeneralInfo = async (title) => {
  const response = await getData(`/data/general-info/${title}`);
  // API returns { status: true, data: payload }
  return response?.data != null ? response.data : response;
};
